/** A plain string is a paragraph; a string array is a bullet list. */
export type FaqBlock = string | string[]

export interface FaqItem {
  question: string
  answer: FaqBlock[]
}

export const faqs: FaqItem[] = [
  {
    question: 'How do I receive the material?',
    answer: [
      'You receive digital access immediately after payment.',
      'The material is delivered in PDF format so you can download it and use it from your phone, tablet, laptop or computer.',
      'You can also print the pages you want to use courtside.',
    ],
  },
  {
    question: 'Is this only for experienced volleyball coaches?',
    answer: [
      'No.',
      'VOLLEYBALL 360 READY™ is designed to be clear and practical for new coaches, youth coaches, school coaches, PE teachers, assistant coaches and more experienced coaches who want a faster planning system.',
      'The visual structure makes it especially useful if you do not want to build every practice from scratch.',
    ],
  },
  {
    question: 'Is this only for youth volleyball?',
    answer: [
      'No.',
      'The system is especially useful for youth, school, club and developing teams, but many of the fundamentals, progressions and planning tools can be adapted to different age groups and ability levels.',
    ],
  },
  {
    question: 'Do I have to follow the practices exactly?',
    answer: [
      'No.',
      'You can use the READY 60™ practices exactly as written or adapt:',
      [
        'Duration',
        'Player numbers',
        'Difficulty',
        'Court space',
        'Equipment',
        'Progressions',
      ],
      'to your own team.',
    ],
  },
  {
    question: 'Does it include videos?',
    answer: [
      'No.',
      'VOLLEYBALL 360 READY™ is a 100% digital PDF visual coaching system.',
      'It uses step-by-step images, diagrams, progressions and visual explanations instead of video lessons.',
    ],
  },
  {
    question: 'Can I download and print the material?',
    answer: [
      'Yes.',
      'You can download the PDF files and print the pages you want to use during practice.',
    ],
  },
  {
    question: 'Is it a subscription?',
    answer: [
      'No.',
      'It is a one-time payment.',
      'There are no monthly subscription fees.',
    ],
  },
  {
    question: 'Is everything in English?',
    answer: [
      'Yes.',
      'The complete VOLLEYBALL 360 READY™ system is provided in English.',
    ],
  },
  {
    question: 'How does the 7-day guarantee work?',
    answer: [
      'After purchase, verify that you can access the material and that the files match the offer described on this page.',
      'If you experience an access issue, an incomplete file, or something delivered does not match the description, contact us within 7 days.',
      'We will first work to resolve the issue.',
      'If we cannot resolve it, you will receive a refund.',
    ],
  },
]
